import { createPortal } from "react-dom";
import Div from "../Div";
import Form from "../Form";
import FormButton from "../FormButton";
import { useState } from "react";
import { sendGoDaddyNotification } from "../../http/renewalHttp/RenewalHttp";
import Input from "../Input";
// import { Autocomplete, TextField } from '@mui/material'

export default function SendNotificationModalGoDaddy({ notify, handleClicked, productList, ...props }) {
  // const [customer, setCustomer] = useState(notify);
  const [contacts, setContacts] = useState([])
//   const [additionalContacts, setAdditionalContacts] = useState([]); // Array to store additional email & phone inputs
//   const [removedContacts, setRemovedContacts] = useState([]); // Array to store removed contacts (email:phone string)
//   const [addedContacts, setAddedContacts] = useState([]); // Array to store added contacts (email:phone string)
 
  function handleClose() {
    handleClicked(false);
  }

  function handleInputChange(field, event) {
    const updatedContacts = [...contacts];
    updatedContacts[field] = event.target.value;
    setContacts(updatedContacts);
  }


  function handleRemoveContact(index) {
    setContacts(contacts.filter((_, i) => i !== index));
  }

  function handleSendNotification(event) {
    event.preventDefault();
    const data = new FormData(event.target);

    const dataEntries = Object.fromEntries(data.entries());
    const requestBody = {
      domain_name: notify?.domain_name,
      sr_no: notify?.sr_no,
      description: notify?.description,
      // emails: contacts.map(c => c.email).filter(email => email),
      // phones: contacts.map(c => c.phone).filter(phone => phone),
      // mobiles: contacts.map(c => c.mobiles).filter(mobiles => mobiles),
      email: notify.email,
      invoice_date: notify.invoice_date,
      invoice_no : notify.invoice_no,
      plain_name: notify.domain_name,
      // product_type : notify.invoice_type,
      product_type : dataEntries.product_type,
      expiry_date : notify.expiry_date,
      Renewal_date : notify.Renewal_date,
      billing_freq : notify.billing_freq,
      place_of_contact_formatted : notify.place_of_contact_formatted,
      price : contacts.price ? contacts.price : 0,
    };
    // console.log(requestBody)
    console.log("Sending Data:", requestBody);
    sendGoDaddyNotification(requestBody);
    handleClicked(false)
    // window.location.reload();
  }

  console.log(productList);
  return (
    notify && createPortal(
      <Div className="modal-backdrop">
        <dialog {...props} style={{ zIndex: 1, maxWidth: "100%" }}>
          <Div className="form-group">Send Notification</Div>
          <Form onSubmit={handleSendNotification}>
            <Div className="form-group">
              {/* <Autocomplete options={productList.map(item => item.invoice_type)} renderInput={(params)=> <TextField {...params} label='Product Type'/>}/> */}
              <Input name="email" onChange={(event) => handleInputChange("email", event)} 
              value={contacts.email ? contacts.email : notify.email} type="text" className="form-control" />
            </Div>
            <Div className="form-group">
              {/* <Autocomplete options={productList.map(item => item.invoice_type)} renderInput={(params)=> <TextField {...params} label='Product Type'/>}/> */}
              <Input value={contacts.product_type ? contacts.product_type : notify.invoice_type} name="product_type" 
              onChange={(event) => handleInputChange("product_type", event)} type="text" className="form-control" />
            </Div>

            <Div className="form-group">
              <label>Customer Name</label>
              <Input value={notify.domain_name} name="customer_name" type="text" className="form-control" disabled />
            </Div>

            <Div className="form-group">
              <label>Description</label>
              <Input value={notify.description} name="company_name" type="text" className="form-control" disabled />
            </Div>

            <Div className='form-group'>
              <label>Price</label>
              <Input type='number' name="price" onChange={(event) => handleInputChange("price", event)} 
              className='form-control' placeholder='10'/>
            </Div>

            {contacts.map((contact, index) => (
              <Div className="form-group" key={index} style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flexGrow: 1 }}>
                  <label>Email</label>
                  <Input value={contact.email} type="text" onChange={(event) => handleInputChange(index, "email", event)} className="form-control" />
                </div>
                <div style={{ flexGrow: 1 }}>
                  <label>Phone</label>
                  {/* {console.log(contact)} */}
                  <Input value={contact.phone} type="text" onChange={(event) => handleInputChange(index, "phone", event)} className="form-control" />
                </div>
                <FormButton type="button" onClick={() => handleRemoveContact(index)} className="btn btn-danger" style={{ marginTop: "30px", marginLeft: "10px" }}>
                  Remove
                </FormButton>
              </Div>
            ))}

            <Div className="form-group">
              <Div className="row">
                <Div className="col-sm-6">
                  <FormButton type="submit" className="btn btn-primary submit-btn btn-block">Send Notification</FormButton>
                </Div>
                <Div className="col-sm-6">
                  <FormButton type="button" onClick={handleClose} className="btn btn-primary submit-btn btn-block">Close</FormButton>
                </Div>
              </Div>
            </Div>
          </Form>
        </dialog>
      </Div>,
      document.getElementById("modal")
    )
  );
}
